import { Component, OnInit, OnChanges, SimpleChange } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubShellComponent } from '../../shared/sub-shell.component';
import { FileUploader } from 'ng2-file-upload';
import { IChangeCallback, IContract, IFile } from '../../_entities';
import { ContractBase } from "./contract.base";
import { ContractService, FileService } from '../../_services';


@Component({
    selector: 'contract-document',
    template: require('./contract-document.component.html')
})
export class ContractDocumentComponent extends ContractBase implements OnInit {
	constructor(
		private fileService: FileService,
		protected readonly contractService: ContractService) {
		super(contractService);
	}


	public uploader: FileUploader;

	public hasBaseDropZoneOver: boolean = false;

	public fileOverBase(e: any): void {
		this.hasBaseDropZoneOver = e;
	}


	ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {

		if (changes['contract'] && this.contract) {

			this.uploader.options.url = `/api/contract/${this.contract.id}/document`;
		}
	}

	ngOnInit(): void {
		this.uploader = new FileUploader({ autoUpload: true });
		this.uploader.onCompleteItem = (fileItem: any, response: any) => {
			this.contract.documents.push(JSON.parse(response));
		};
	}

	ngOnDestroy(): void {
	}

	public isPdf(file: IFile) {
		return file.ext.toLowerCase().endsWith("pdf");
	}

	public isImage(file: IFile) {

		var ext = file.ext.toLowerCase();

		return ext.endsWith("png") ||
			ext.endsWith("jpg") ||
			ext.endsWith("jpeg") ||
			ext.endsWith("bmp") ||
			ext.endsWith("gif");
	}

	public isDocument(file: IFile) {
		return !this.isImage(file);
	}


	public isPng(file: IFile) {
		return file.ext.toLowerCase().endsWith("png");
	}
	
	onDocumentChange(id: number, event: IChangeCallback<any>) {

		//let data = {};
		//data[event.id] = event.newValue;

		const patches = [
			{ "op": "replace", "path": `/${event.id}`, "value": event.newValue }
		];

		this.fileService.patchContractDocument(this.contract.id, id, patches).then((result) => {
			this.contract.documents.forEach((item, i) => { if (item.id === id) this.contract.documents[i] = result; });
			event.resolve();
		}).catch((err) => { event.reject(err); });;
	}

	onDocumentDelete(id: number, event: any) {
		this.fileService.deleteFile(id).then(() => {
			this.contract.documents = this.contract.documents.filter(i => i.id !== id);
		}).catch((err) => { console.log(err); });;
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-document.component.ts